import { COLOR_OPTIONS } from 'config/style';
import { Trans, useTranslation } from 'react-i18next';
import {
  Container,
  HowToInterpret,
  HowToInterpretWrapper,
  InfoIcon,
  Notes,
  NotesWrapper,
  PestManagementWrapper,
  RiskLevel,
  RiskLevelWrapper,
  TopicItem,
  Topics
} from './daily-counts-tab.styles';

const DailyCountsTab = () => {
  const [t] = useTranslation();

  return (
    <Container data-testid='daily-counts-tab'>
      <NotesWrapper>
        <div>
          <Trans>{t('pages.regional_overview.digital_traps.info_button.digital_traps.highlighted_message')}</Trans>
        </div>
        <Notes data-testid='daily-counts-notes'>
          <div>
            <Trans>{t('pages.regional_overview.digital_traps.info_button.digital_traps.note_1')}</Trans>
          </div>
          <div>
            <Trans>{t('pages.regional_overview.digital_traps.info_button.digital_traps.note_2')}</Trans>
          </div>
          <div>
            <Trans>{t('pages.regional_overview.digital_traps.info_button.digital_traps.note_3')}</Trans>
          </div>
          <div>
            <Trans>{t('pages.regional_overview.digital_traps.info_button.digital_traps.note_4')}</Trans>
          </div>
          <div>
            <Trans>{t('pages.regional_overview.digital_traps.info_button.digital_traps.note_5')}</Trans>
          </div>
        </Notes>
      </NotesWrapper>
      <HowToInterpretWrapper>
        <HowToInterpret>
          <InfoIcon />
          <Trans>{t('pages.regional_overview.digital_traps.info_button.how_to')}</Trans>
        </HowToInterpret>
        <Topics>
          <TopicItem>
            <Trans>{t('pages.regional_overview.digital_traps.info_button.digital_traps.topic_1')}</Trans>
          </TopicItem>
          <TopicItem>
            <Trans>{t('pages.regional_overview.digital_traps.info_button.digital_traps.topic_2')}</Trans>
          </TopicItem>
        </Topics>
      </HowToInterpretWrapper>
      <PestManagementWrapper>
        <div>
          <Trans>{t('pages.regional_overview.digital_traps.info_button.pest_management')}</Trans>
        </div>
      </PestManagementWrapper>
      <RiskLevelWrapper data-testid='risk-level-wrapper'>
        <RiskLevel $backgroundColor={'#ABEAAE'} $color={COLOR_OPTIONS.NEUTRAL_80}>
          <Trans>{t('pages.disease_risk.low')}</Trans>
        </RiskLevel>
        <RiskLevel $backgroundColor={'#F4FF80'} $color={COLOR_OPTIONS.NEUTRAL_80}>
          <Trans>{t('pages.disease_risk.medium')}</Trans>
        </RiskLevel>
        <RiskLevel $backgroundColor={'#FF643A'} $color={COLOR_OPTIONS.NEUTRAL_00}>
          <Trans>{t('pages.disease_risk.high')}</Trans>
        </RiskLevel>
      </RiskLevelWrapper>
    </Container>
  );
};

export default DailyCountsTab;
